import { MaintenanceItem } from 'types/graphql'

export const isLedgerInProgress = (
  maintenanceItem: Partial<MaintenanceItem>
) => {
  return ['IN_PROGRESS', 'IN_REVIEW'].includes(
    maintenanceItem.complianceLedger?.status
  )
}

export const isRevisionInProgress = (
  maintenanceItem: Partial<MaintenanceItem>
) => {
  return maintenanceItem.complianceLedger?.isRevision
}

export const isLogbookInProgress = (maintenanceItem) => {
  return (
    maintenanceItem.complianceLedger?.status === 'SIGN' &&
    (maintenanceItem.complianceLedger?.MaintenanceLogbook?.length === 0 ||
      maintenanceItem.complianceLedger?.MaintenanceLogbook?.every(
        (log) => log.status === 'DRAFT'
      ))
  )
}

export const isLogbookAwaitingSignature = (maintenanceItem) => {
  return (
    maintenanceItem.complianceLedger?.status === 'SIGN' &&
    maintenanceItem.complianceLedger?.MaintenanceLogbook?.length > 0 &&
    maintenanceItem.complianceLedger?.MaintenanceLogbook?.every(
      (log) => log.status === 'PUBLISHED'
    )
  )
}

export const isWorkOrderInProgress = (maintenanceItem) => {
  return !!maintenanceItem.workOrderIdInProgress
}

export const isMaintenanceItemInProgress = (
  maintenanceItem: Partial<MaintenanceItem>
) => {
  return (
    isLedgerInProgress(maintenanceItem) ||
    isRevisionInProgress(maintenanceItem) ||
    isLogbookInProgress(maintenanceItem) ||
    isLogbookAwaitingSignature(maintenanceItem) ||
    isWorkOrderInProgress(maintenanceItem)
  )
}

export const inProgressValues = (maintenanceItem) => {
  return {
    isLedgerInProgress: isLedgerInProgress(maintenanceItem),
    isRevisionInProgress: isRevisionInProgress(maintenanceItem),
    isLogbookInProgress: isLogbookInProgress(maintenanceItem),
    isLogbookAwaitingSignature: isLogbookAwaitingSignature(maintenanceItem),
    isWorkOrderInProgress: isWorkOrderInProgress(maintenanceItem),
    isMaintenanceItemInProgress: isMaintenanceItemInProgress(maintenanceItem),
  }
}
